<template>
  <BaseTableWrapper>
    <template #top-buttons>
      <selectedInvoicesSum :selected-invoices="selectedInvoices" />
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
        <b-button aria-controls="invoice_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.invoice_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="invoice_search_collapse" class="mt-2">
          <InvoiceFiltering
            :filters="$store.state.filters.invoiceNotAcceptedFilter"
            :filterReference="$store.state.filters.invoiceNotAcceptedReference"
            :currentPageProp="$store.state.filters.invoiceNotAcceptedCurrentPage"
            :periodDateProp="$store.state.filters.invoiceNotAcceptedPeriodDate"
            :dateTypeProp="$store.state.filters.invoiceNotAcceptedDateType"
            @currentPageChange="$store.state.filters.invoiceNotAcceptedCurrentPage = $event"
            @periodDateChange="$store.state.filters.invoiceNotAcceptedPeriodDate = $event"
            @dateTypeChange="$store.state.filters.invoiceNotAcceptedDateType = $event"
            @getPage="getPage($event)" ref="invoiceNotAcceptedFiltering"></InvoiceFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <b-row>
        <b-col>
          <div v-if="isLoading">
            <Loader></Loader>
          </div>
          <div v-else-if="!isLoading && items.length < 1">
            {{ $t('views.exsbinvoices.list.noInvoices') }}
          </div>
          <div v-else>
            <table class="table table-sm table-responsive-md table-striped table-hover">
              <thead>
              <tr>
                <th class="text-center">
                  <b-form-checkbox @change="toggleSelectCurrentPage()" :checked="checkboxSelectAllStatus"  :indeterminate="checkboxSelectIndeterminateStatus"></b-form-checkbox>
                </th>
                <th>{{ $t('views.exsbinvoices.list.type') }}</th>
                <th>{{ $t('views.exsbinvoices.list.seller') }}</th>
                <th>{{ $t('views.exsbinvoices.list.buyer') }}</th>
                <th>{{ $t('views.exsbinvoices.list.agreementTags') }}</th>
                <th>{{ $t('views.appconfiguration.invoiceConfiguration.invoiceComment') }}</th>
                <th>{{ $t('views.exsbinvoices.list.sellDate') }}</th>
                <th>{{ $t('views.exsbinvoices.list.paymentDeadline') }}</th>
                <th>{{ $t('views.exsbinvoices.list.totalValueNetto') }}</th>
                <th>{{ $t('views.exsbinvoices.list.totalValueBrutto') }}</th>
                <th>{{ $t('views.exsbinvoices.list.lastContractorInvoice') }}</th>
                <th colspan="2" />
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items" :key="item['@id']">
                <td class="text-center">
                  <b-form-checkbox
                    v-model="selectedInvoices"
                    :value="item"
                  ></b-form-checkbox>
                </td>
                <td>
                  <router-link
                    :to="{name: 'EXSBInvoiceShow', params: { id: item['@id'] }}"
                    v-b-tooltip.hover :title="$t('buttons.goto')" aria-hidden="true"
                  ><span v-if="item.invoiceType.name">{{item.invoiceType.name}}</span></router-link>
                  <span v-if="item.invoiceCorrectionOf">
                    <br>
                    <small>
                      <router-link :to="{name: 'EXSBInvoiceShow', params: { id: item.invoiceCorrectionOf['@id'] }}">
                        <span class="text-danger">
                          {{ $t('views.exsbinvoices.form.corOf') }} {{ item.invoiceCorrectionOf.number }}
                        </span>
                      </router-link>
                    </small>
                  </span>
                </td>
                <td>
                  {{ item.sellerName }}
                </td>
                <td>
                  <router-link :to="{name: 'FirmShow', params: { id: item.idUserData['@id'] }}">
                    <div>{{ item.buyerName }}</div>
                  </router-link>
                  <router-link v-if="item.idAgreement" :to="{name: 'EXABAgreementShow', params: {id: item.idAgreement['@id']}}"><b-badge>{{ $t('views.excmdevice.show.clientSection.deviceAgreement.moveToAgreement') }}</b-badge></router-link>
                </td>
                <td>
                  <template v-if="item.idAgreement">
                    <p class="m-0 p-0" v-for="tag in item.idAgreement.agreementTags" :key="tag['@id']">
                      <b-badge pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
                    </p>
                  </template>
                </td>
                <td>
                  <i v-if="item.comments" class="fa fa-eye fa-lg ml-4" :id="'invoice_info' + item['@id']"></i>
                  <b-popover custom-class="box-shadow shadow-sm bg-white rounded"
                             triggers="hover" placement="top" variant="secondary" :target="'invoice_info' + item['@id']">
                    <span>{{item.comments}}</span>
                  </b-popover>
                </td>
                <td>
                  {{ $moment(item['sellDate']).format('YYYY-MM-DD') }}
                </td>
                <td>
                  {{ $moment(item['paymentDeadline']).format('YYYY-MM-DD') }}
                </td>
                <td>
                  {{ item['totalValueNetto'].toFixed(2) }}
                </td>
                <td>
                  {{ item['totalValueBrutto'].toFixed(2) }}
                </td>
                <td>
                  <p class="m-0 p-0" v-if="item.lastContractorInvoiceTotalValueBrutto">{{ item.lastContractorInvoiceTotalValueBrutto.toFixed(2)}}</p>
                  <router-link v-if="item.lastContractorInvoiceId" :to="{name: 'EXSBInvoiceShow', params: { id: '/core/public/index.php/api/e_x_s_b_invoices/' + item.lastContractorInvoiceId }}"><b-badge>{{ $t('buttons.goToInvoice') }} <span v-if="item.lastContractorInvoiceNumber">{{item.lastContractorInvoiceNumber}}</span></b-badge></router-link>
                </td>
                <td>
                  <b-dropdown variant="link" size="sm" right text="Right align">
                    <template #button-content>
                      <i class="fa fa-bars fa-lg"></i>
                    </template>
                    <b-dropdown-item @click="editSingle(item['@id'])"><i class="fa fa-edit"></i> {{$t('buttons.edit')}}</b-dropdown-item>
                    <b-dropdown-item @click="generateInvoiceFromAgreementAgain(item)"><i class="fa fa-calculator"></i> {{$t('views.agreements.list.options.generateInvoiceFromAgreementAgain')}}</b-dropdown-item>
                    <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              <tr v-if="items.length > 0 && totalSums && totalSums.length > 0">
                <td colspan="7">{{ $t('views.exsbinvoices.form.totalSums') }}</td>
                <td>{{ totalSums[0].sumTotalValueNetto }}</td>
                <td colspan="2">{{ totalSums[0].sumTotalValueBrutto }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="view">
            <pagination
              :view="view"
              :totalItems="totalItems"
              @getPage="getPage($event)"
              @getPageNumber="setCurrentPage($event.page)"
            ></pagination>
          </div>
          <p>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedInvoices.length }}</b></p>
          <button type="button" class="btn btn-sm btn-warning float-left" @click="selectAll()"> {{ $t('buttons.selectAll') }} </button>
          <button type="button" class="btn btn-sm btn-warning float-left" @click="unSelectAll()"> {{ $t('buttons.unSelectAll') }} </button>
          <b-dropdown size="sm" variant="warning" dropright text="Drop-Right">
            <template #button-content>
              {{ $t('buttons.collectionOperations') }}
            </template>
            <b-dropdown-item @click="acceptSelectedInvoices"><i class="fa fa-file-check mr-2"></i>{{$t('views.exsbinvoices.list.acceptSelectedInvoices')}}</b-dropdown-item>
            <b-dropdown-item @click="generateInvoiceFromAgreementsAgain"><i class="fa fa-calculator mr-2"></i>{{$t('views.exsbinvoices.list.generateInvoiceFromAgreementAgain')}}</b-dropdown-item>
            <b-dropdown-item @click="removeSelectedInvoices"><i class="fa fa-trash mr-2"></i>{{$t('views.exsbinvoices.list.removeSelectedInvoices')}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <InvoiceAcceptModal @reload="reload()" :selections="selectedInvoices"></InvoiceAcceptModal>
        <GenerateInvoicesFromAgreementModal @reset="reload()" :regenerate="1" :id-collection="selectedAgreements"></GenerateInvoicesFromAgreementModal>
      </b-row>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../../Layout/Loader'
import Pagination from '../../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import InvoiceFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/InvoiceFiltering'
import getId from '../../../../../../utils/getIdFromLink'
import remove from '@/utils/remove'
import InvoiceAcceptModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceAcceptModal'
import GenerateInvoicesFromAgreementModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/GenerateinvoicesFromAgreementModal'
import SelectedInvoicesSum from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/SelectedInvoicesSum'
import addParamsToQuery from '@/utils/addParamsToQuery'

export default {
  data () {
    return {
      selectedInvoices: [],
      selectedAgreements: [],
      selectedItem: '',
      searchParams: this.$store.state.filters.invoiceNotAcceptedFilter
    }
  },
  components: {
    SelectedInvoicesSum,
    GenerateInvoicesFromAgreementModal,
    InvoiceAcceptModal,
    Loader,
    Pagination,
    BaseTableWrapper,
    InvoiceFiltering
  },
  props: {
    firmIRI: {
      type: String
    },
    accepted: {
      default: () => 1
    }
  },
  computed: {
    ...mapGetters({
      deletedItem: 'exsbinvoice/del/deleted',
      error: 'exsbinvoice/list/error',
      items: 'exsbinvoice/list/items',
      isLoading: 'exsbinvoice/list/isLoading',
      view: 'exsbinvoice/list/view',
      totalItems: 'exsbinvoice/list/totalItems',
      totalSums: 'exsbinvoice/list/totalSums'
    }),
    filterStatus () {
      return (
        (JSON.stringify(this.$store.state.filters.invoiceNotAcceptedFilter) !== JSON.stringify(this.$store.state.filters.invoiceNotAcceptedReference)) ||
          this.$store.state.filters.invoiceNotAcceptedPeriodDate !== '' ||
          this.$store.state.filters.invoiceNotAcceptedDateType !== 1
      )
    },
    checkboxSelectAllStatus () {
      // Sprawdzenie czy wszystkie elementy z items znajdują się w selectedInvoices. Kolejność nie ma znaczenia
      return this.items.every(item => this.selectedInvoices.includes(item))
    },
    checkboxSelectIndeterminateStatus () {
      if (this.checkboxSelectAllStatus) {
        return false
      }
      return this.items.some(item => this.selectedInvoices.includes(item))
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBInvoiceList')
    if (Object.keys(this.$store.state.filters.invoiceNotAcceptedReference).length === 0) {
      this.$store.state.filters.invoiceNotAcceptedReference = {
        number: '',
        buyerFilter: '',
        invoicePositionsFilter: '',
        invoiceType: '',
        invoiceStatus: '',
        correctionFilter: null,
        order: 0,
        paymentWay: '',
        'paymentDeadline[after]': '',
        'paymentDeadline[before]': '',
        'issueDate[after]': '',
        'issueDate[before]': '',
        'sellDate[after]': '',
        'sellDate[before]': '',
        issuePlace: '',
        accepted: 0,
        sent: '',
        comments: '',
        'idUserData.userDataTags.idTag': [],
        'idAgreement.agreementTags.tag': [],
        ksefStatusFilter: 0,
        hasDiscountFilter: ''
      }
    }
    if (Object.keys(this.$store.state.filters.invoiceNotAcceptedFilter).length === 0) {
      this.$store.state.filters.invoiceNotAcceptedFilter = JSON.parse(JSON.stringify(this.$store.state.filters.invoiceNotAcceptedReference))
    }
  },
  watch: {
    accepted () {
      this.getList()
    }
  },
  created () {
    this.getList()
    this.channelBusinessInvoice = this.$store.state.Pusher.subscribe('e_x_s_b_invoices')
    this.channelBusinessInvoice.bind('e_x_s_b_invoices', data => {
      this.getList()
    })
  },
  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_invoices')
  },
  methods: {
    ...mapMutations({
      toggleInvoiceAcceptModal: 'exsbinvoice/acceptModal/toggleModal',
      toggleGenerateInvoicesFromAgreementsModal: 'agreements/generateInvoicesFromAgreementModal/toggleModal'
    }),
    clearFilters () {
      if (this.$refs.invoiceNotAcceptedFiltering) {
        this.$refs.invoiceNotAcceptedFiltering.clearFilters()
      }
    },
    selectAll () {
      let selectAll = []
      for (let i in this.items) {
        selectAll.push(this.items[i])
      }
      this.selectedInvoices = selectAll
    },
    unSelectAll () {
      this.selectedInvoices = []
    },
    toggleSelectCurrentPage () {
      if (this.checkboxSelectAllStatus) {
        // Usuń wszystkie checkboxy z bieżącej strony
        this.selectedInvoices = this.selectedInvoices.filter(item => !this.items.includes(item))
      } else {
        // Dodaj brakujące elementy z bieżącej strony
        this.selectedInvoices = [...this.selectedInvoices, ...this.items.filter(item => !this.selectedInvoices.includes(item))]
      }
    },
    editSingle (id) {
      this.$router.push({ name: 'EXSBInvoiceUpdate', params: { id: id } })
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getList()
      })
    },
    generateInvoiceFromAgreementAgain (item) {
      this.selectedAgreements = [getId(item.idAgreement['@id'])]
      this.toggleGenerateInvoicesFromAgreementsModal()
    },
    generateInvoiceFromAgreementsAgain () {
      this.selectedAgreements = []
      for (let i in this.selectedInvoices) {
        this.selectedAgreements.push(getId(this.selectedInvoices[i].idAgreement['@id']))
      }
      this.toggleGenerateInvoicesFromAgreementsModal()
    },
    getList () {
      let params = Object.assign({ '_page': this.$store.state.filters.invoiceNotAcceptedCurrentPage }, this.searchParams)
      if (typeof params.order !== 'undefined') {
        if (params.order === 1) {
          params['order[createdAt]'] = 'desc'
        } else if (params.order === 0) {
          params['order[issueDate]'] = 'desc'
          params['order[numberValue]'] = 'desc'
          params['order[batchNumber]'] = 'desc'
        } else if (params.order === 2) {
          params['order[issueDate]'] = 'desc'
          params['order[batchNumber]'] = 'desc'
          params['order[numberValue]'] = 'desc'
        } else if (params.order === 3) {
          params['order[sellDate]'] = 'desc'
          params['order[batchNumber]'] = 'desc'
          params['order[numberValue]'] = 'desc'
        }
      }
      params.order = undefined
      let url = addParamsToQuery('e_x_s_b_invoices', params)
      this.getPage(url)
    },
    setCurrentPage (page) {
      this.$store.state.filters.invoiceNotAcceptedCurrentPage = page
    },
    reload () {
      this.getPage(this.view['@id'])
      this.$emit('reload')
    },
    resetSelectedItems () {
      this.selectedInvoices = []
    },
    acceptSelectedInvoices () {
      this.toggleInvoiceAcceptModal()
    },
    removeSelectedInvoices () {
      let selections = []
      for (let i in this.selectedInvoices) {
        selections.push(this.getIdLink(this.selectedInvoices[i]['@id']))
      }
      let params = {
        selections: selections
      }
      remove('e_x_s_b_invoicesdelete',
        () => {
          this.getList()
          this.unSelectAll()
        },
        () => {},
        params)
    },
    getIdLink (link) {
      return getId(link)
    },
    ...mapActions({
      getPage: 'exsbinvoice/list/getItems'
    })
  }
}
</script>
